import React from 'react';

const Footer = () => {
    return (
        <footer className="text-center p-3">
            <span className="text-white">&copy;2020 / Marcin Kuna / All rights reserved</span>
        </footer>
    )
}

export default Footer;